import React, { useState, useEffect, useRef } from "react";

const SearchableSelect = ({
  id,
  options = [],
  className = "",
  value = "",
  onChange,
}) => {
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  // Filter options based on search input
  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(search.toLowerCase())
  );

  // Select an option
  const handleSelect = (option) => {
    setSearch(option.label);
    setIsOpen(false);
    onChange({
      target: {
        id,
        value: option.value || "",
      },
    });
  };

  // Clear the input
  const handleClear = () => {
    setSearch("");
    onChange({
      target: {
        id,
        value: "",
      },
    });
    setIsOpen(false);
  };

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={wrapperRef} className={`relative w-full ${className}`}>
      <div className="relative">
        <input
          type="text"
          id={id}
          value={
            search || options.find((opt) => opt.value === value)?.label || ""
          }
          onChange={(e) => {
            setSearch(e.target.value);
            onChange({
              target: {
                value: "",
              },
            });
            setIsOpen(true);
          }}
          onFocus={() => setIsOpen(true)}
          placeholder="search/select"
          className="w-full border border-slate-300 rounded-sm h-8 pl-1 pr-6 focus:outline-none"
        />

        {/* Cross Button */}
        {search || value ? (
          <button
            type="button"
            onClick={handleClear}
            className="absolute right-1 top-1/2 -translate-y-1/2 text-red-500 font-bold"
          >
            ✕
          </button>
        ) : (
          <></>
        )}
      </div>

      {isOpen && (
        <ul className="absolute z-10 w-full bg-white dark:bg-gray-800 border border-gray-300 rounded mt-1 max-h-40 overflow-y-auto">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <li
                key={index}
                onClick={() => handleSelect(option)}
                className="p-2 hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer"
              >
                {option.label}
              </li>
            ))
          ) : (
            <li className="p-2 text-gray-500">No results</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default SearchableSelect;
